import PropTypes from 'prop-types';
import '../styles/components/Button.css';

export const BUTTON_TYPES = {
    primary: 'primary-btn',
    outline: 'outline-btn',
    danger: 'danger-btn',
    success: 'success-btn'
};

/**
 * Generic button component.
 * 
 * @param {object} props
 * @param {string} props.id - button ID
 * @param {string} props.type - classes assigned to the button
 * @param {string} props.buttonText - text displayed on the button
 * @param {Function} props.action - function to run when the button is clicked
 * @param {ReactNode} props.icon - optional icon component
 */
export const Button = ({ id, type, buttonText, action, style }) => {
    return (
        <button id={id} className={type} onClick={action} style={style}>
            {buttonText}
        </button>
    );
};

Button.propTypes = {
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    action: PropTypes.func.isRequired,
};

export default Button;